import * as PoziUtils from 'api/utils'
import type { ConfigLayerOptions } from 'config/ConfigLayer'
import { ConfigLayerType } from 'config/ConfigLayerType'

export interface ConfigLayerFolderOptions extends ConfigLayerOptions {
  depth: number
  folder: boolean
  layers?: ConfigLayerOptions[]
  type: ConfigLayerType
}

// Factory function to create options for a folder layer
export function createConfigLayerFolder(options: Partial<ConfigLayerOptions> = {}, depth?: number): ConfigLayerFolderOptions {
  return {
    depth: depth || 0,
    folder: true,
    group: options.group || '',
    groupid: PoziUtils.getPoziIDFromString(options.group || ''),
    layers: [],
    title: options.title || '',
    titleid: PoziUtils.getPoziIDFromString(options.title || ''),
    type: ConfigLayerType.FOLDER,
    ...options
  }
}